<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>{{ total }} tickets</span>
        </h1>
      </template>
    </page-nav-bar>

    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="false"
      :has-padd-right-normal="true">
      <div class="is-border">
        <div class="row-width-actions-bar is-border-bottom">
          <div class="columns is-gapless">
            <transition
              enter-active-class="animated fadeIn fasterx2"
              leave-active-class="animated fadeOut fasterx2"
              mode="out-in">
              <div
                class="column is-narrow has-background-primary has-text-white is-flex"
                v-if="hasFilter">
                <div
                  class="is-self-centered is-padding-left is-padding-right"
                  :data-count="count">
                  Résultat : {{ count }} ticket(s)
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom">
          <div class="field is-grouped">
            <p
              class="control"
              v-for="status in activationStatus"
              :key="status.value">
              <label
                class="checkbox checkRadioIsHide"
                :for="status.value">
                <input
                  :id="status.value"
                  :name="status.name"
                  type="checkbox"
                  :value="status.value"
                  v-model="filters.status"
                  @click="updateSimpleFilter">
                <span
                  class="tag"
                  :class="status.color">
                  <span>{{ status.label }}</span><span class="icon"><i
                    class="far"
                    :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'"></i></span>
                </span>
              </label>
            </p>
          </div>
        </div>
        <filters-tags
          id="ticket-tag"
          :has-filter="hasFilter"
          :filters="filters"
          :ignore-tags="['status']"
          @reset="resetFilters"
          @update="beforeUpdateFromTag($event)"></filters-tags>
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true">
          <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-6">
                <th class="has-text-centered">
                </th>
                <th>Date</th>
                <th>Sujet</th>
                <th>Titre</th>
                <th>Société</th>
                <th>Utilisateur</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th class="has-text-centered"></th>
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr
                v-for="(ticket) in items"
                :key="ticket.pk"
                class="is-size-6"
                :id="'e' + ticket.pk">
                <td class="is-paddingless has-text-centered is-vcentered">
                  <span
                    :data-tooltip="filterStatus[ticket.status].label"
                    class="dot tooltip is-tooltip-right"
                    :class="ticket.status|dotClass"></span>
                </td>
                <td class="has-cursor-pointer">
                  <router-link :to="{name: 'TicketVue', params: { id: ticket.pk }}">
                    {{ ticket.created_on | dtFormat('DD/MM/YYYY HH:mm') }}
                  </router-link>
                </td>
                <td class="has-cursor-pointer">
                  <router-link :to="{name: 'TicketVue', params: { id: ticket.pk }}">
                    {{ ticket.subject | ticketSubject }}
                  </router-link>
                </td>
                <td>{{ ticket.title }}</td>
                <td v-if="isDistributeur">
                  {{ ticket.promoteur.name }}
                </td>
                <td
                  class="has-cursor-pointer"
                  v-else>
                  <router-link :to="{name: 'CompanyVue', params: { id: ticket.user.account.pk }}">
                    {{ ticket.user.account.name }}
                  </router-link>
                </td>
                <td class="has-cursor-pointer">
                  <router-link :to="{name: 'UserVue', params: { id: ticket.user.pk }}">
                    {{ ticket.user.last_name }} {{ ticket.user.first_name }}
                  </router-link>
                </td>
                <td>{{ ticket.user.email }}</td>
                <td><phone-number :phone="ticket.user.phone"></phone-number></td>
                <td class="has-text-centered">
                  <display-button-list
                    :buttons="buttonList"
                    :data="ticket"
                    :hide-text-when-solo="true">
                  </display-button-list>
                </td>
              </tr>
              <!--<tr class="empty empty--row" v-for="n in items.length < 4 ? 4 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucun ticket disponible
            </h2>
            <a
              class="has-text-primary"
              @click="resetFilters"
              v-if="hasFilter"><span class="icon"><i class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
          </div>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { GenericList, Filter, Sort, DefaultValues, FilterGetter } from '@/mixins'
export default {
  name: 'TicketList',
  ...mapState(['currentUser']),
  filters: {
    dotClass (value) {
      const COLORS = {
        'new': 'has-background-success',
        'in_progress': 'has-background-warning',
        'closed': 'has-background-draft'
      }
      return COLORS[value]
    }

  },
  mixins: [GenericList, Filter, Sort, DefaultValues, FilterGetter],
  data () {
    return {
      setQueryAtStart: true,
      activationStatus: [
        { value: 'new', label: 'Nouveau', color: 'is-success' },
        { value: 'in_progress', label: 'En cours', color: 'is-warning' },
        { value: 'closed', label: 'Fermé', color: 'is-draft' }
      ],
      buttonList: [
        {
          action: (id, ticket) => {
            this.$router.push({ name: 'TicketVue', params: { id } })
          },
          icon: 'fa-eye',
          text: 'Voir'
        },
        {
          action: (id, ticket) => {
            this.updateTicket(id, 'in_progress', 'Ticket pris en charge')
          },
          icon: 'fa-check',
          text: 'Prendre en charge le ticket',
          display: (ticket) => {
            return ticket.status === 'new' && (this.currentUser.pk !== ticket.user.pk)
          }
        },
        {
          action: async (id, ticket) => {
            let value = await this.$swal({
              title: 'Cloturer un ticket',
              text: 'Cette action entrainera la cloture du ticket. Vous pourrez le consulter et télécharger les pièces jointes mais il ne sera plus possible d\'envoyer ni de recevoir de messages.',
              cancelButtonText: 'Annuler',
              confirmButtonText: 'Valider'
            })
            if (value.dismiss) return null
            this.updateTicket(id, 'closed', 'Ticket cloturé')
          },
          icon: 'fa-times',
          text: 'Clore le ticket',
          display: (ticket) => {
            return (ticket.status === 'new' || ticket.status === 'in_progress') && (this.currentUser.pk !== ticket.user.pk)
          }
        }
      ],
      loadDocuments: this.loadItems,
      filters: {
        status: ['new', 'in_progress']
      },
      initFilters: {
        status: []
      },
      service: 'TICKET',
      items: []
    }
  },
  computed: {
    ...mapState(['isDistributeur', 'currentUser']),
    today () {
      return moment()
    }
  },
  created () {
    if ('status' in this.$route.query && this.$route.query.status) {
      this.filters.status = this.$route.query.status.isArray ? this.$route.query.status : [this.$route.query.status]
    }
  },
  methods: {
    async updateTicket (id, status, text) {
      let params = {
        status
      }
      try {
        await this.$api.patch(this.$resources.TICKET, id, params)
        this.$toasted.global.success(text)
        this.loadDocuments()
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la modification du ticket')
      }
    }
  }
}
</script>
